import { Navigate, useLocation } from 'react-router-dom'
import { useRecoilValue } from 'recoil'

import { useAdminMessage } from '@/modules/healthblocks/hooks/useAdminMessage'
import { useTenantHref } from '@/modules/shared/hooks/useTenantHref'
import { modeAtom } from '@/utils/qa-mode'

import type { FC, ReactNode } from 'react'

/**
 * A route that protects the app from being accessed when an admin message is blocking.
 */
const ProtectedAdminMessageRoute: FC<{ children: ReactNode }> = ({ children }) => {
  // Poll for admin message every 3 minutes
  const { adminMessage } = useAdminMessage({ refreshInterval: 1000 * 60 * 3 })
  const location = useLocation()
  const tenantHref = useTenantHref()
  const mode = useRecoilValue(modeAtom)

  if (adminMessage?.blocking && mode !== 'qa' && !location.pathname.endsWith('/blocking-admin-message')) {
    return <Navigate to={tenantHref('/blocking-admin-message')} replace />
  }

  return <>{children}</>
}

export { ProtectedAdminMessageRoute }
